import React from 'react';
export const SkipMainContent = () => {
    return (
        <a className="usa-skipnav usa-link usa-link" href="#main-content">Skip to main content</a>
    );
};